import illustration1 from 'assets/img/icons/spot-illustrations/50.png';
import illustration2 from 'assets/img/icons/spot-illustrations/49.png';
import illustration3 from 'assets/img/icons/spot-illustrations/48.png';

export default [
 {
  icon: ['far', 'lightbulb'],
  iconText: 'PLAN',
  color: 'danger',
  title: 'Planes de Salud y Bienestar',
  description:
   'Con Fortis Control, la administración de los planes de salud y el seguimiento del bienestar de tus mascotas se vuelve más eficiente y enfocada en su cuidado. Agiliza la gestión de historiales clínicos, tratamientos y recordatorios, mantén un control preciso de la salud de tus pacientes y realiza un seguimiento efectivo de su progreso.',
  image: illustration1
 },
 {
  icon: ['far', 'object-ungroup'],
  iconText: 'BUILD',
  color: 'info',
  title: 'Equipo de Profesionales Dedicados',
  description:
   'Conéctate con nuestros veterinarios expertos, técnicos veterinarios y especialistas en cuidado animal, todo en un mismo lugar. Amplía el cuidado que podemos ofrecer a tu mascota y accede a un abanico de servicios sin límites. Maximiza el bienestar de tu compañero a través de un equipo veterinario integral. ¡Únete a nuestra familia Fortis Control y lleva la salud de tu mascota al siguiente nivel! Construye bienestar y alcanza la salud óptima.',
  image: illustration2,
  inverse: true
 },
 {
  icon: ['far', 'paper-plane'],
  iconText: 'DEPLOY',
  color: 'success',
  title: 'Gestión Integral de Pacientes',
  description:
   'Descubre el poder de Fortis Control, con nuestro sistema integral de gestión de pacientes. Mantente conectado con la salud de tu mascota a través de recordatorios de citas y seguimiento de tratamientos. Organiza tus visitas fácilmente con una gestión eficiente de la agenda. Accede al historial clínico de tu mascota de forma rápida y segura. El bienestar de tu mascota está a solo un clic de distancia. Organiza las citas, accede al historial y recibe recordatorios importantes.',
  image: illustration3
 }
];
